import * as React from 'react'
import styled from 'styled-components'
import { BASE_BREAKPOINTS } from '../../../utils/enhancers/withResponsive'

const StyledInfoBoxContainer = styled.div`
  margin-bottom: 16px;
`

const StyledTitle = styled.div`
  font-weight: bold;
  margin-bottom: 12px;

  @media screen and (max-width: ${BASE_BREAKPOINTS.md}px) {
    display: block;
  }
`

const StyledDescription = styled.div`
  line-height: 22px;
`

const InfoBoxContainer = ({ description }) => (
  <StyledInfoBoxContainer>
    <StyledTitle>Ce qu’en pensent les habitants : </StyledTitle>
    <StyledDescription dangerouslySetInnerHTML={{ __html: description }} />
  </StyledInfoBoxContainer>
)

export default InfoBoxContainer
